import { render } from "./AgendaListView.vue?vue&type=template&id=08f11cc7&scoped=true"
import script from "./AgendaListView.vue?vue&type=script&lang=js"
export * from "./AgendaListView.vue?vue&type=script&lang=js"

import "./AgendaListView.vue?vue&type=style&index=0&id=08f11cc7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f11cc7"]])

export default __exports__